"use client";

import React from 'react';
import { Card, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ElectronicsDetailsFormProps {
  details: Record<string, any>;
  setDetails: (details: Record<string, any>) => void;
  loading: boolean;
  noAutocomplete?: boolean;
}

const ElectronicsDetailsForm: React.FC<ElectronicsDetailsFormProps> = ({ details, setDetails, loading }) => {
  const handleChange = (field: string, value: any) => {
    setDetails({ ...details, [field]: value });
  } 

  return (
    <Card className="p-4 border">
      <CardTitle className="text-lg mb-4">Detalles de Electrónica</CardTitle>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="grid gap-2">
          <Label htmlFor="electronics-storage">Almacenamiento (opcional)</Label>
          <Input
            id="electronics-storage"
            type="text"
            placeholder="Ej: 256GB, 1TB"
            value={details.storage || ''}
            onChange={(e) => handleChange('storage', e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="electronics-ram">RAM (opcional)</Label>
          <Input
            id="electronics-ram"
            type="text"
            placeholder="Ej: 8GB"
            value={details.ram || ''}
            onChange={(e) => handleChange('ram', e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="electronics-processor">Procesador (opcional)</Label>
          <Input
            id="electronics-processor"
            type="text"
            placeholder="Ej: Snapdragon 8 Gen 2"
            value={details.processor || ''}
            onChange={(e) => handleChange('processor', e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
    </Card>
  );
};

export default ElectronicsDetailsForm;